<template>
  <div class="preview-container" @click="redirectToOgURL()">

    <div v-if="!hasImage()">
       <div class="small-og-tags-container">
          <div class="small-og-image-container" >
            <img src="../../assets/share/small_og.svg" class="no_preview_img"/>
          </div>
          <div class="small-og-information">
            <div class="small-og-tags-title">{{ title }}</div>
            <div class="small-og-tags-description">{{ shortenedDescription }}</div>
            <div class="small-og-tags-domain">{{ urlDomain }}</div>
          </div>      
        </div>
    </div>

    <div v-else>
        <div class="og-tags-container"  v-if="!isSmallImage()">
          <div class="post-text">
            <ProcessedPostText :content="content" :OGLinkToRemove="url" />
          </div>
          <div class="og-image-container">
            <img :src="image" width="100%" height="auto" />
          </div>

          <div class="og-tags-title-domain">
            <div class="og-tags-title">
              <p>{{ title }}</p>
            </div>
            <div class="og-tags-domain">
              <p>{{ urlDomain }}</p>
            </div>
          </div>
        </div>

        <div class="small-og-tags-container" v-else>
            <div class="small-og-image-container" >
              <img :src="image" width="100%" height="auto" />
            </div>
            <div class="small-og-information">
              <div class="small-og-tags-title">{{ title }}</div>
              <div class="small-og-tags-description">{{ shortenedDescription }}</div>
              <div class="small-og-tags-domain">{{ urlDomain }}</div>
            </div>      
        </div>
    </div>
  </div>
</template>

<script>
import { getDomainFromURL } from "../../../../helpers/formatters.js";
import ProcessedPostText from "./processed-text.vue";
import { cutText } from "./helpers.js";

export default {
  components: {
    ProcessedPostText: ProcessedPostText,
  },
  data() {
    return {
      loading: true,
      imgLoaded: false,
    };
  },
  props: ["title", "url", "description", "image", "width", "height", "content"],
  methods: {
    hasImage() {
      return this.image ? true : false;
    },
    isSmallImage() {
      return this.width < 500;
    },
    loadImage() {
      return new Promise((resolve, reject) => {
        if (!this.image) return reject();

        const img = new Image();

        img.addEventListener("load", () => resolve(this));
        img.addEventListener("error", () => reject());

        img.src = this.image;
      });
    },
    redirectToOgURL() {
      window.location.href = this.url;
    },
  },
  computed: {
    shortenedDescription() {
      if (this.description) {
        return cutText(this.description, 25);
      } else return null;
    },
    urlDomain() {
      return getDomainFromURL(this.url);
    },
  },
  beforeMount() {
    this.loadImage()
      .then(() => (this.imgLoaded = true))
      .catch(() => {})
      .finally(() => (this.loading = false));
  },
};
</script>

<style scoped>
.preview-container {
  width: 100%;
  line-height: 1.3;
}

/** SMALL  OG-TAGS STYLING  */
.small-og-tags-container {
  height: 10vh;
  width: 15vw;
  max-height: 10vh;
  display: flex;
  flex-direction: row;
  width: 100%;
}

.small-og-image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  width: 20%;
}
.small-og-image-container img {
  flex-shrink: 0;
  min-width: 100%;
  min-height: 100%;

}
.no_preview_img {
  width: auto;
  height: auto;
}

.small-og-information {
  font-size: 0.9rem;
  color: white;
  grid-column-start: 2;
  grid-column-end: 11;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.5rem;
  background-color: #e3eeff;
  padding-left: 0.5rem;
  width: 80%;
}

.small-og-tags-title {
  color: #020213;
}

.small-og-tags-description {
  color: #929197;
}

.small-og-tags-domain {
  color: #4d4d4d;
}

/** BIG OG-TAGS STYLING  */
.og-image-container {
  height: 30vh;
  display: flex;
  justify-content: center;
}

.og-image-container img {
  width: 100%;
  height: auto;
  object-fit: cover;
}

p {
  color: black;
  margin: 0;
  padding: 0;
}

.og-tags-title p {
  font-weight: bold;
}
.og-tags-domain p {
}
.og-tags-container {
  background-color: white;
  width: 100%;
}
.og-tags-title-domain {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0.5rem;
  padding-bottom: 1rem;
}

.post-text {
  background-color: black;
  padding: 0.5rem;
  color: white;
  font-size: 3vh;
  overflow-wrap: break-word;
}

@media only screen and (max-width: 50px) {
  .post-text p {
    color: white;
    font-size: 0.8rem;
  }
}
@media only screen and (max-width: 300px) {
  .post-text p {
    color: white;
    font-size: 0.8rem;
  }
}

@media only screen and (min-width: 650px) {
}
@media only screen and (min-width: 650px) and (max-height: 550px) {
}
@media only screen and (min-width: 800px) {
}
@media only screen and (max-height: 650px) and (min-width: 800px) {
}
@media only screen and (min-height: 1024px) {
}
</style>